@if (currentStepConfig) {
  @for (config of stepsConfigs; track config) {
    <ng-container *ngTemplateOutlet="stepTemplate; context: { $implicit: config }"></ng-container>
  }

  <ng-template #stepTemplate let-config>
    @let _currentStep = currentStepConfig.step;
    @let _step = config.step;
    @let _description = config.description;

    <div class="step" [class.step-current]="_step === _currentStep" [title]="_description">
      @if (_step < _currentStep) {
        <span class="visually-hidden">Abgeschlossen: </span>
      }
      @if (_step === _currentStep) {
        <span class="visually-hidden">Aktueller Schritt: </span>
      }
      <span>{{ _step }}</span>
      <span class="visually-hidden">{{ _description }}</span>
    </div>
  </ng-template>
}
